import React from "react";
import { FluentProvider, teamsDarkTheme, Button, Select } from "@fluentui/react-components";
import { CheckmarkRegular } from "@fluentui/react-icons";
import { observer } from "mobx-react-lite";
import { useMsTeamsInMeetingApps } from "../hooks/hooks";
import { useStore } from "../../stores/Stores";
import { msTeamsMeetingRolesEnum } from "../enum/msTeamsMeetingRolesEnum";
import styles from "../styles/inMeetingApp.module.scss";
import { useTranslation } from "../../shared/translation/Translation";
import { LanguageVersion } from "../../shared/types/LanguageVersion";

const OrganizerMeetingTypePrompt: React.FC = observer(() => {
    const inMeetingAppContext = useMsTeamsInMeetingApps();
    const { inMeetingAppStore, userStore } = useStore();
    const messages = useTranslation();

    React.useEffect(() => {
        if (inMeetingAppContext.meetingId !== "") {
            inMeetingAppStore.getMeetingTypeDictionary(LanguageVersion[userStore.languageVersion].toLowerCase());
            inMeetingAppStore.getParticipantData(inMeetingAppContext.meetingId);
            setIsLoading(false);
        }
    }, [inMeetingAppContext.meetingId, inMeetingAppStore]);

    const [meetingType, setMeetingType] = React.useState<number | null>(null);
    const [showFinish, setShowFinish] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    const onButtonClick = () => {
        inMeetingAppStore.setMeetingType(inMeetingAppContext.meetingId, { meetingType: meetingType });
        setShowFinish(true);
    };

    if (isLoading) {
        return null;
    }

    return (
        <FluentProvider theme={teamsDarkTheme}>
            <div className={styles.meetingTypePromptContainer}>
                {inMeetingAppStore.participantData.role !== msTeamsMeetingRolesEnum.organizer ? (
                    <h3 className={styles.meetingTypePromptHeader}>
                        {messages.organizerMeetingTypePrompt.headerOnStartNotAnOrganizer}
                    </h3>
                ) : showFinish ? (
                    <>
                        <h3 className={styles.meetingTypePromptHeader}>
                            {messages.organizerMeetingTypePrompt.headerOnFinish}
                        </h3>
                        <CheckmarkRegular className={styles.meetingTypePromptAcceptIcon} style={{ fontSize: "48px" }} />
                    </>
                ) : (
                    <>
                        <h3 className={styles.meetingTypePromptHeader}>
                            {messages.organizerMeetingTypePrompt.headerOnStartOrganizer}
                        </h3>
                        <Select
                            className={styles.meetingTypeDropDown}
                            onChange={(_, data) => {
                                const found = inMeetingAppStore.meetingTypeDictionary.find((x) => x.key === data.value);
                                setMeetingType(found?.value ?? null);
                            }}
                        >
                            <option value="">{messages.organizerMeetingTypePrompt.placeholderMeetingType}</option>
                            {inMeetingAppStore.meetingTypeDictionary.map((x) => (
                                <option key={x.key} value={x.key}>
                                    {x.key}
                                </option>
                            ))}
                        </Select>
                        <Button appearance="primary" disabled={meetingType === null} onClick={onButtonClick}>
                            {messages.organizerMeetingTypePrompt.save}
                        </Button>
                    </>
                )}
            </div>
        </FluentProvider>
    );
});

export default OrganizerMeetingTypePrompt;
